import { render, staticRenderFns } from "./RenewPurchase.vue?vue&type=template&id=f448676e&scoped=true"
import script from "./RenewPurchase.vue?vue&type=script&lang=js"
export * from "./RenewPurchase.vue?vue&type=script&lang=js"
import style0 from "./RenewPurchase.vue?vue&type=style&index=0&id=f448676e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f448676e",
  null
  
)

export default component.exports